import { cn } from "@/lib/utils";

const MAP = {
  critical: "bg-primary/15 text-primary border-primary/40",
  high:     "bg-warning/15 text-warning border-warning/40",
  medium:   "bg-info/15 text-info border-info/40",
  low:      "bg-muted text-muted-foreground border-border",
};

export const SeverityBadge = ({ level = "low", className }) => (
  <span className={cn(
    "inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-[10px] font-mono font-semibold uppercase tracking-widest border",
    MAP[level] || MAP.low,
    className
  )}>
    <span className={cn("h-1.5 w-1.5 rounded-full", {
      "bg-primary": level === "critical",
      "bg-warning": level === "high",
      "bg-info": level === "medium",
      "bg-muted-foreground": level === "low",
    })} />
    {level}
  </span>
);

export default SeverityBadge;
